import { Navigate, NavLink, Outlet } from 'react-router-dom';
import { useMe } from '@/lib/me';

const TABS = [
  { to: '/admin', label: 'Overview', end: true },
  { to: '/admin/requests', label: 'Requests' },
  { to: '/admin/organizations', label: 'Organizations' },
  { to: '/admin/users', label: 'Users' },
  { to: '/admin/library', label: 'Library' },
  { to: '/admin/audit', label: 'Audit log' },
];

/**
 * Platform admin console. Hiding it from non-admins is a convenience only:
 * every /v1/admin route checks the admin flag on the server.
 */
export function AdminLayout() {
  const me = useMe();
  if (me.isPending) return <p className="text-sm text-muted-foreground">Loading…</p>;
  if (!me.data?.isPlatformAdmin) return <Navigate to="/home" replace />;
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold">Platform admin</h1>
        <nav className="mt-4 flex flex-wrap gap-1 border-b border-border">
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              end={t.end}
              className={({ isActive }) =>
                `-mb-px border-b-2 px-3 py-2 text-sm ${isActive ? 'border-primary font-medium text-foreground' : 'border-transparent text-muted-foreground hover:text-foreground'}`
              }
            >
              {t.label}
            </NavLink>
          ))}
        </nav>
      </div>
      <Outlet />
    </div>
  );
}
